import React, { Fragment, lazy, Suspense, useEffect, useState } from "react";
import FlashMessage from "@/Components/FlashMessage";
import { usePage } from "@inertiajs/inertia-react";
import TopBar from "@/Components/TopBar/TopBar";
import { Inertia } from "@inertiajs/inertia";
import UpdatePaymentDetailsModal from "@/Components/Modals/UpdatePaymentDetailsModal";
import axios from "axios";

export var cbInstance;

export default function Authenticated({
    children,
    className = "",
    hideTopBar = false,
}) {
    let modal = usePage().props.modal;
    let flash = usePage().props.flash;


    if (flash) {
        flash.fixPosition = true;
    }

    let requiresBillingDetails = false;
    if (usePage().props.auth) {
        requiresBillingDetails =
            usePage().props.auth.current_organization?.requires_billing_details;
    }

    const [state, setState] = useState({
        payment_due: false,
        payment_failed: false,
        showUpdatePaymentModal: false,
    });

    useEffect(() => {
        Inertia.on("success", () =>
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
        );
        if (requiresBillingDetails) {
            if (
                sessionStorage.getItem("payment_due") === null &&
                sessionStorage.getItem("payment_failed") === null
            ) {
                axios
                    .post(route("easytithe"))
                    .then((response) => {
                        if (
                            response.data.payment_due !== undefined &&
                            response.data.payment_failed !== undefined
                        ) {
                            setState({
                                ...state,
                                payment_due: response.data.payment_due,
                                payment_failed: response.data.payment_failed,
                            });
                            sessionStorage.setItem(
                                "payment_due",
                                response.data.payment_due
                            );
                            sessionStorage.setItem(
                                "payment_failed",
                                response.data.payment_failed
                            );
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                setState({
                    ...state,
                    payment_due:
                        sessionStorage.getItem("payment_due") === "true",
                    payment_failed:
                        sessionStorage.getItem("payment_failed") === "true",
                });
            }
        }
    }, []);

    useEffect(() => {
        if (state.payment_due || state.payment_failed) {
            setState({ ...state, showUpdatePaymentModal: true });
        }
    }, [state.payment_due, state.payment_failed]);

    return (
        <Fragment>
            <div
                className={`authenticated ${className ? " " + className : ""}`}
            >
                {!hideTopBar && <TopBar></TopBar>}
                {state.showUpdatePaymentModal && (
                    <UpdatePaymentDetailsModal
                        isOpen={state.showUpdatePaymentModal}
                        paymentDue={state.payment_due}
                        paymentFailed={state.payment_failed}
                    ></UpdatePaymentDetailsModal>
                )}
                {flash && loadFlashMessage()}
                {children}
            </div>
            {modal && !state.showUpdatePaymentModal && loadModal()}
        </Fragment>
    );

    /**
     * If the session sent back a modal request, load it here
     */
    function loadModal() {
        const Modal = lazy(() =>
            import(`../Components/Modals/${modal.component}`)
        );
        return (
            <Suspense fallback="">
                {React.createElement(Modal, { ...modal.data })}
            </Suspense>
        );
    }

    function loadFlashMessage() {
        return React.createElement(FlashMessage, { ...flash });
    }
}
